/* unplugin-vue-components disabled */import script from "./CretaceousHomeView.vue?vue&type=script&lang=js&setup=true"
export * from "./CretaceousHomeView.vue?vue&type=script&lang=js&setup=true"

import "./CretaceousHomeView.vue?vue&type=style&index=0&id=4f7df5dc&lang=css"

const __exports__ = script;

export default __exports__